import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/sysFile',
  title: window.language['menu.client.upgrade'],
  component: dynamicWrapper(app, [import('../../HomePage/model'),import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/System/SysFile/index.js